import { Injectable } from '@angular/core';
import { FormGroup, AbstractControl, ValidationErrors, Validators, ValidatorFn } from '@angular/forms';

@Injectable()
export class FormService {

    constructor() {}

    // retrieve a FormControl
    getFormControl(form: FormGroup, name: string) {
        return form.get(name);
    }

    // returns TRUE if the FormControl is valid
    isValid(form: FormGroup, name: string) {
        var e = this.getFormControl(form, name);
        return e && e.valid;
    }

    // returns TRUE if the FormControl has been changed
    isChanged(form: FormGroup, name: string) {
        var e = this.getFormControl(form, name);
        return e && (e.dirty || e.touched);
    }

    // returns TRUE if the FormControl is invalid after user changes
    hasError(form: FormGroup, name: string) {

        if (form) {

            var e = this.getFormControl(form, name);
            return e && (e.dirty || e.touched) && !e.valid;

        }

        return true;
        
    }

    hasCodeError(form: FormGroup, name: string, code: string) {

        if (form) {

            var e = this.getFormControl(form, name);
            return e && (e.dirty || e.touched) && e.hasError(code);

        }

        return true;

    }

    hasRequiredError(form: FormGroup, name: string) {

        if (form) {

            var e = this.getFormControl(form, name);
            return e && (e.dirty || e.touched) && e.hasError("required");

        }

        return true;

    }

    hasNumberError(form: FormGroup, name: string) {

        if (form) {

            var e = this.getFormControl(form, name);
            return e && (e.dirty || e.touched) && e.hasError("hasNumber");

        }

        return true;

    }

    hasCapitalCaseError(form: FormGroup, name: string) {

        if (form) {

            var e = this.getFormControl(form, name);
            return e && (e.dirty || e.touched) && e.hasError("hasCapitalCase");

        }

        return true;

    }

    hasSmallCaseError(form: FormGroup, name: string) {

        if (form) {

            var e = this.getFormControl(form, name);
            return e && (e.dirty || e.touched) && e.hasError("hasSmallCase");

        }

        return true;

    }

    hasMinLengthError(form: FormGroup, name: string) {

        if (form) {

            var e = this.getFormControl(form, name);
            return e && (e.dirty || e.touched) && e.hasError("minlength");

        }

        return true;

    }

    hasNoPasswordMatchError(form: FormGroup, name: string) {

        if (form) {

            var e = this.getFormControl(form, name);
            return e && (e.dirty || e.touched) && e.hasError('noPasswordMatch');

        }

        return true;

    }

    emailValidator(control: AbstractControl): ValidationErrors {
        if (!control.value) {
            return null;
        }

        return Validators.email(control);
    }

    patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {

        return (control: AbstractControl): { [key: string]: any } => {
            if (!control.value) {
                return null;
            }

            // test the value of the control against the regexp supplied
            const valid = regex.test(control.value);

            // if true, return no error (no error), else return error passed in the second parameter
            return valid ? null : error;
        };

    }

    passwordMatchValidator(control: AbstractControl) {
        const password: string = control.get('Password').value; // get password from our password form control
        const confirmPassword: string = control.get('PasswordConfirm').value; // get password from our confirmPassword form control
        // compare is the password math
        if (password !== confirmPassword) {
            // if they don't match, set an error in our confirmPassword form control
            control.get('PasswordConfirm').setErrors({ noPasswordMatch: true });
        }
    }

}


// WEBPACK FOOTER //
// ./ClientApp/app/_services/form.service.ts